export default {
  pripomienky: {
    add: {
      withParams(cisloLegMaterialu: string): string {
        return `/pripomienky/legislativne-procesy/SK/${cisloLegMaterialu}/pripomienky/pridaj`;
      },
    },
    list: {
      withParams(cisloLegMaterialu: string): string {
        return `/pripomienky/legislativne-procesy/SK/${cisloLegMaterialu}/pripomienky/zobraz`;
      },
    },
  },
  vyjadrenia: {
    list: {
      withParams(cisloLegMaterialu: string): string {
        return `/sprava-vyjadreni/legislativne-procesy/SK/${cisloLegMaterialu}/vyjadrenia/zobraz`;
      },
    },
  },
  aktEu: {
    detail: {
      withParams(aktEuUuid: string): string {
        return `${process.env.REACT_APP_PORTAL_MAIN_URL}/pravo-eu/navrhy-aktov-eu/${aktEuUuid}`;
      },
    },
  },
  rss: {
    legislativnyMaterial: {
      list: `${process.env.REACT_APP_RSS_URL}`,
      detail: {
        // eslint-disable-next-line max-len
        raw: `${process.env.REACT_APP_BACKEND_REST_API}/internal/elegislativa/legislativne-materialy/:type/:year/:index/rss`,
        withParams: (type: string, year: number, index: number):
            // eslint-disable-next-line max-len
            string => `${process.env.REACT_APP_BACKEND_REST_API}/internal/elegislativa/legislativne-materialy/${type}/${year}/${index}/rss`,
      },
    },
  },
};
